/* Copy da listagem de usuários: header, CTA de criação (super_admin), estado de erro e o botão de
   paginação. Filtros e tabela são componentes externos (`components/users/*`) — fora do escopo
   desta área. */
import type { Bilingual } from '../bilingual.js';
import { useBilingual } from '../locale-provider.js';

interface UsersListContent {
  readonly title: string;
  readonly description: string;
  readonly createUser: string;
  readonly loadFailed: string;
  readonly loadMore: string;
}

const USERS_LIST_CONTENT: Bilingual<UsersListContent> = {
  'pt-BR': {
    title: 'Usuários',
    description: 'Contas de usuário — licenças, dispositivos, sessões e auditoria.',
    createUser: 'Novo usuário',
    loadFailed: 'Falha ao carregar usuários.',
    loadMore: 'Carregar mais',
  },
  'en-US': {
    title: 'Users',
    description: 'User accounts — licenses, devices, sessions, and audit.',
    createUser: 'New user',
    loadFailed: 'Failed to load users.',
    loadMore: 'Load more',
  },
};

export const useUsersListContent = (): UsersListContent => useBilingual(USERS_LIST_CONTENT);
